/*
Process list actions from user lists
 */
window.listActions = (() => {

	function execute(actionData) {
		fetch('/wp-admin/admin-ajax.php?action=list_action', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(actionData),
		})
			.then(response => response.json())
			.then(data => {
				if (data.success === false) {
					alert('Error: ' + data.data);
					return;
				}
				if (actionData.type === 'vcard') {
					alert('VCard was sent to your email address');
				}
			})
			.catch((error) => {
				alert('Error: ' + error);
			});
	}

	return {
		execute
	};

})();